import { useGetAgroOverviewMapVariablesQuery } from 'services/api/Meteorology/Agro/Overview';
import useOverviewErrorState from './useOverviewErrorState';

/**
 * Opções do seletor "Variável exibida" do mapa — dinâmicas via rota
 * mapa/variaveis (DECISÃO-8, nada hardcoded). O default do FE é 'arm'
 * (reducer), ignorando deliberadamente o `default: true` da fonte.
 */
export default function useOverviewMapVariables() {
  const {
    data, error, isFetching, refetch,
  } = useGetAgroOverviewMapVariablesQuery();
  const errorKind = useOverviewErrorState(error, isFetching);

  return {
    variables: data, isFetching, errorKind, retry: refetch,
  };
}
